<template>
    <div>
        <Toolbar>
            <BackButton v-if="$page.props.previous_url"/>
        </Toolbar>
        <Card>
            <div class="row">
                <div class="col-xl-12">
                    <form>
                        <FormGroupNew :label="__('contact.issue')" required>
                            <select v-model="form.issue" class="form-control" id="select-issue" required>
                                <option disabled selected value>{{ __('contact.select_issue') }}</option>
                                <option v-for="(issue, key) in  issues"  :value="key">{{ issue }}</option>
                            </select>
                        </FormGroupNew>
                        <FormGroupNew :label="__('contact.select_stores')" v-if="stores">
                            <div class="row">
                                <div class="col-lg-3 col-md-6 mt-2" v-for="store in stores">
                                    <input type="checkbox" :value="store.id" v-model="form.selectedStores" :disabled="stores.length === 1"  />
                                    <label :for="store.id">{{ store.attributes.name }}</label>
                                </div>
                            </div>
                        </FormGroupNew>
                        <FormGroupNew :label="__('contact.message')" required>
                            <textarea v-model="form.message" class="form-control" id="message-input" rows="6"
                                      :placeholder="__('contact.message_placeholder')"
                                      required></textarea>
                        </FormGroupNew>
                        <div>
                            <button class="btn btn-primary" @click="submit">{{ __('actions.send') }}</button>
                        </div>
                    </form>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>

import Card from "@components/Cards/Card.vue";
import Toolbar from "@components/Toolbar.vue";
import BackButton from "@components/BackButton.vue";
import FormGroupNew from '@components/Form/FormGroupNew.vue';

export default {
    components: {
        FormGroupNew,
        BackButton,
        Toolbar,
        Card,
    },

    props: {
        stores: Array,
        issues: Object,
    },

    data() {
        return {
            form: this.$inertia.form({
                issue: null,
                selectedStores: [],
                message: "",
            }),

        }
    },

    mounted() {
        if(this.stores.length === 1) {
            this.form.selectedStores.push(this.stores[0].id)
        }
    },

    methods: {
        submit() {
            this.form.post(this.$route('contact.send'));
        }
    },
}
</script>
